/* eslint-disable @nx/enforce-module-boundaries */
import React, { useEffect, useState } from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  HStack,
  Avatar,
  Stack,
  Heading,
  Text,
  Portal,
  Button,
  VStack,
  Box,
} from '@mybridge/ui';
import { useDispatch, useSelector } from 'react-redux';
import {
  getUserFullName,
  getUserProfilePic,
  getUserExperience,
} from 'v4/lib/commons';
import Link from 'next/link';
import MyBridgeAvatar from 'v4/components/common/MyBridgeAvatar';
import { useContext } from 'react';
import { SearchContext, SearchTabs } from 'v4/snippets/search/context';
import { setOpenAuthModal } from 'v4/store/actions/auth.actions';
import { SkeletonCircle, SkeletonText } from '@mybridge/ui';
import { myBridgeData } from 'v4/components/header/status-dropdown/constant';
const MobileDrawerMenu = ({ onClose, onOpen }) => {
  const { loggedIn, pageLoaded } = useSelector((state) => state.user);
  const { activeTab, setActiveTab, query, allSearch } =
    useContext(SearchContext);
    const [randomThreeMessages, setRandomThreeMessages] = useState([]);
  const { userProfileInfo, loading } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();
  const userFullName = getUserFullName(userProfileInfo);
  const userProfilePic = getUserProfilePic(userProfileInfo);
  const userExperience = getUserExperience(userProfileInfo);

  const menu = SearchTabs?.()?.filter?.((menuItem, ind) =>
    query?.query?.length ? true : ind > 0
  );




  useEffect(() => {
    function getRandomThree(arr) {
      const shuffled = arr.sort(() => 0.5 - Math.random());
      return shuffled.slice(0, 3);
    }

    // Initialize with three random messages on mount
    setRandomThreeMessages(getRandomThree(myBridgeData));
  }, []);
  return (
    <Drawer placement="left" onClose={onClose} isOpen={onOpen}>
      <DrawerOverlay />
      <Portal>
        <DrawerContent>
          {loggedIn && (
            <DrawerHeader borderBottomWidth="1px">
              <Link onClick={(e) => onClose()} href="/profile/me">
                <HStack 
                  _focus={{ boxShadow: 'none', outline: 'none' }}
                  _focusVisible={{ boxShadow: 'none', outline: 'none' }}
                >
                  {loading ? <SkeletonCircle size='10' /> : <MyBridgeAvatar
                    name={userFullName}
                    src={userProfilePic}
                    size="md"
                  />}
                  
                  <Stack spacing="0">
                    {loading ? <><SkeletonText mt='4' noOfLines={2} spacing='4' skeletonHeight='3' /></> : <>
                    <Heading size="xs">{userFullName}</Heading>
                    <Text size="xs" fontWeight="400">
                      {userExperience?.title} at {userExperience?.company_name}
                    </Text>
                    </>}
                    
                  </Stack>
                </HStack>
              </Link>
            </DrawerHeader>
          )}

          <DrawerBody>
            {!loggedIn && (
              <Stack alignItems="center" borderRadius="8px" border="1px solid #D9D9D9" spacing={2} my={2} p={4}>
                <Heading color="#3D5A80" fontSize="18px" fontWeight="500">New to myBridge?</Heading>
                <center>Sign up now to get your own personalized timeline!</center>

                <Button width="100%" borderRadius="50px" variant="primary" onClick={(e) => dispatch(setOpenAuthModal('sign-up'))}>Create Account</Button>
                <Button width="100%" borderRadius="50px" variant="whiteOutline" fontWeight="500" onClick={(e) => dispatch(setOpenAuthModal('sign-in'))}>Log in</Button>
              </Stack>
            )}
            <Stack mt={6}>
              <Heading fontSize="17px" fontWeight="500" color="#3D5A80">Searches</Heading>
              {menu?.map?.((mi, miIndex) => (
                <HStack
                  // className={Styles.tab}
                  _hover={{
                    bgColor: 'gray.100',
                  }}
                  borderColor="transparent"
                  bgColor={mi.name === activeTab ? 'brandGray.500' : ''}
                  // p={2}
                  borderRadius="full"
                  key={miIndex}
                  gap="2"
                  alignItems="center"
                  cursor="pointer"
                  onClick={(e) => {setActiveTab(mi?.name); onClose();}}
                  justifyContent="flex-start"
                  {...(mi.link ? { as: Link, href: mi.link } : {})}
                >
                  <HStack
                    bg={mi.name === activeTab ? 'brandPrimary.500' : '#D9D9D9'}
                    alignItems="center"
                    justifyContent="center"
                    w="10"
                    h="10"
                    borderRadius="full"
                    p={2}
                  >
                    {mi?.icon?.(
                      mi.name === activeTab ? { color: 'white' } : {color: '#365E7D',extraColor:"#68A4D1"}
                    )}
                  </HStack>
                  <Text pr="4">{mi.title}</Text>
                </HStack>
              ))}
            </Stack>
           

                {randomThreeMessages?.map((content) => (
                  <Box
                    bg="#ECECEC"
                    boxShadow="0px 4px 4px 0px #00000040"
                    mt={4}

                    minH="175px"
                    border="1px solid #E4E6EB"
                    borderRadius={"16px"}
                  >
                    <Stack p={2}>
                      <Text color="#617898" fontSize="19px">
                        {content?.heading}
                      </Text>
                      <VStack>
                        <Text color="#5B5B5B" fontSize="15px">
                          {content?.description}
                        </Text>
                      </VStack>
                    </Stack>
                  </Box>
                ))}
                
          </DrawerBody>
        </DrawerContent>
      </Portal>
    </Drawer>
  );
};

export default MobileDrawerMenu;
